<template>
  <div v-if="showApp">
    <page-calendar></page-calendar>
  </div>
</template>

<script>
import PageCalendar from "@/projects/planning-livraison/components/page-calendar.vue";

export default {
  data() {
    return {
      showApp: false,
    };
  },
  mounted() {
    let appsToShow = this.$store.state.webApplicationToShow;
    let currentApp = this.$route.fullPath.replace("/", "");
    if (appsToShow.includes(currentApp)) this.showApp = true;
  },
  components: {
    PageCalendar,
  },
};
</script>

<style>
</style>